import { createAction } from "@reduxjs/toolkit";

export const getCompany = createAction("GET_COMPANY");
